<div *transloco="let t">
  <div class="wrapper">
    <div class="title-text">
      <div #loginText class="title login">{{ t('loginForm') }}</div>
      <div class="title signup">{{ t('signupForm') }}</div>
    </div>
    <div class="form-container">
      <div class="slide-controls">
        <input type="radio" name="slide" id="login" [checked]="!isSignupMode" />
        <input type="radio" name="slide" id="signup" [checked]="isSignupMode" />
        <label #loginBtn for="login" class="slide login" (click)="moveToLogin()">
          {{ t('loginForm') }}
        </label>
        <label #signupBtn for="signup" class="slide signup" (click)="moveToSignup()">
          {{ t('registrati') }}
        </label>
        <div class="slider-tab"></div>
        <div class="slider-tab"></div>
      </div>
      <div #loginForm class="form-inner">
        <form [formGroup]="loginFormR">
          <div class="field my-3">
            <label for="email" class="text-xs font-medium">Email</label>
            <input
              type="email"
              placeholder="{{ t('validemail') }}"
              name="username"
              formControlName="username"
              class="rounded px-3 py-2 text-sm transition-all duration-300"
              [ngClass]="{
                'border-gray-300 ':
                  loginFormR.get('username')?.valid || !loginFormR.get('username')?.touched,
                'border-red-500 ':
                  loginFormR.get('username')?.invalid && loginFormR.get('username')?.touched
              }" />
            <p
              class="mt-1 text-xs text-red-500"
              *ngIf="
                loginFormR.get('username')?.invalid &&
                loginFormR.get('username')?.touched &&
                loginFormR.get('username')?.value !== ''
              ">
              {{ t('errorfieldemail') }}
            </p>
          </div>
          <div class="field mb-0">
            <label for="password" class="text-xs font-medium">{{ t('labelPassword') }}</label>
            <p-password
              formControlName="password"
              [toggleMask]="true"
              class="font-light"
              placeholder="{{ t('validPassword') }}"
              [feedback]="false"
              inputId="passwordWIthEyes" />
          </div>
          <div class="pass-link mb-4 mt-2 text-xs text-right">
            <a (click)="goToRequestPassword()">{{ t('login.dimenticato') }}</a>
          </div>

          <div
            class="buttonLogin"
            (click)="submitLogin()"
            [ngClass]="{ disabled: isLoginDisabled$ }">
            <span>LOGIN</span>
          </div>
          @if(platform === 'ios') {
          <app-apple-login></app-apple-login>
          }
          <app-google-login></app-google-login>
          <div class="signup-link">
            {{ t('login.non-registrato') }}
            <a (click)="moveToSignup(); $event.preventDefault()">
              {{ t('login.registrati-ora') }}
            </a>
          </div>
        </form>
        <form [formGroup]="signupFormR">
          <div class="field">
            <label for="email" class="text-xs font-medium">Email</label>
            <input
              type="email"
              placeholder="{{ t('validemail') }}"
              formControlName="emailAddress"
              name="emailAddress"
              [ngClass]="{
                'border-gray-300 ':
                  signupFormR.get('emailAddress')?.valid ||
                  !signupFormR.get('emailAddress')?.touched,
                'border-red-500 ':
                  signupFormR.get('emailAddress')?.invalid &&
                  signupFormR.get('emailAddress')?.touched
              }" />
            <p
              class="mt-1 text-xs text-red-500"
              *ngIf="
                signupFormR.get('emailAddress')?.invalid &&
                signupFormR.get('emailAddress')?.touched &&
                signupFormR.get('emailAddress')?.value !== ''
              ">
              {{ t('errorfieldemail') }}
            </p>
          </div>
          <div class="field">
            <label for="password" class="text-xs font-medium">{{ t('labelPasswordmin') }}</label>
            <p-password
              formControlName="password"
              [toggleMask]="true"
              class=""
              placeholder="{{ t('validPassword') }}"
              inputId="passwordWIthEyes"
              weakLabel />
            <p
              class="mt-1 text-xs text-red-500"
              *ngIf="
                signupFormR.get('password')?.invalid &&
                signupFormR.get('password')?.touched &&
                signupFormR.get('password')?.value !== ''
              ">
              {{ t('errorfieldpassword') }}
            </p>
          </div>
          <div class="field">
            <label for="confirmPassword" class="text-xs font-medium">
              {{ t('labelConfirmPassword') }}
            </label>

            <p-password
              formControlName="confirmPassword"
              [toggleMask]="true"
              [feedback]="false"
              class=""
              placeholder="{{ t('validConfirmPassword') }}"
              inputId="passwordWIthEyes" />

            <p
              class="mt-1 text-xs text-red-500"
              *ngIf="
                signupFormR.get('confirmPassword')?.touched &&
                signupFormR.get('confirmPassword')?.value !== signupFormR.get('password')?.value
              ">
              {{ t('labelerrorConfirmPassword') }}
            </p>
          </div>
          <div class="field-checkbox mt-5">
            <p-checkbox
              formControlName="privacyAccepted"
              inputId="privacyAccepted"
              binary="true"></p-checkbox>
            <label for="privacyAccepted" class="text-xs">
              {{ t('login.privacy') }}
              <a (click)="goToPrivacy()" class="underline text-xs">Privacy Policy</a>
              e i
              <a (click)="goToTerms()" class="underline text-xs">
                {{ t('login.terms') }}
              </a>
              .
            </label>
          </div>

          <p-button
            label="{{ t('signupForm') }}"
            (click)="submitSignup()"
            [disabled]="isSignInDisabled$"
            id="signupButton"
            class="block"></p-button>
        </form>
      </div>
    </div>
  </div>
</div>
